var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResuelta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B9519BA1-79B1-48C9-AD7D-3099C4AF35F7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M159.766596,425.91829 C155.255532,422.676446 153,419.169733 153,415.398151 C153,411.312265 156.134007,408 160,408 C163.865993,408 167,411.312265 167,415.398151 C167,419.169702 164.744506,422.676388 160.233517,425.918209 L160.233575,425.918289 C160.09406,426.018551 159.906111,426.018551 159.766596,425.91829 Z M160,417.864202 C161.288664,417.864202 162.333333,416.760113 162.333333,415.398151 C162.333333,414.036189 161.288664,412.932101 160,412.932101 C158.711336,412.932101 157.666667,414.036189 157.666667,415.398151 C157.666667,416.760113 158.711336,417.864202 160,417.864202 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Udala-Zabaltzen-0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kalezaindu_home_mobile",
    transform: "translate(-153.000000, -408.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask-Copy",
    fill: "#21CB00",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResuelta);
export default __webpack_public_path__ + "static/media/Resuelta.569bb97f786f8667a7ca447d19e80fc3.svg";
export { ForwardRef as ReactComponent };